// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import eh_closeBtn_click from "../eventHandlers/eh_closeBtn_click.js";

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const loggerMsgs = {
  initStart: ["init. closeBtn"],
  initSuccess: ["init. closeBtn", "init. success"],
  noValidDOMEl: ["init. closeBtn", "no valid DOM element provided"],
};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_closeBtn() {
  // Setup...
  const { closeBtn } = this.ref;
  const logArgs = { eventName: "init_closeBtn", inline: true };
  this.logger("init", loggerMsgs.initStart, "action", logArgs);

  // Guard...
  if (closeBtn === undefined || !this.validate_refEl(closeBtn)) return this.cancel_featInit(loggerMsgs.noValidDOMEl);

  // Listen to click events on close-btn...
  closeBtn.addEventListener("click", eh_closeBtn_click.bind(this));

  // Conclude...
  this.logger("init", loggerMsgs.initSuccess, "success", logArgs);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
